export enum SubscriberParamTypes {

  BASE_AMMENITY_TYPE =  "BASE_AMMENITY_TYPE",
  SEND_NOTIFICATIONS = "SEND_NOTIFICATIONS",
  FRO_DATE_FROM_WEB = "FRO_DATE_FROM_WEB",
  IGNORE_MULTI_HOTEL = "IGNORE_MULTI_HOTEL",
  SHOW_PERFORMANCE = "SHOW_PERFORMANCE",
  EXTRA_RIGHTS = "EXTRA_RIGHTS",
  CLEANING_WAGE_COSTS = "CLEANING_WAGE_COSTS",
  PARENT_HOTEL = "PARENT_HOTEL",
  CHAT_VISIBILITY = "CHAT_VISIBILTY",
  ADDITIONAL_TASK = "ADDITIONAL_TASK",
  MATERIAL_CONSUMPTION = "MATERIAL_CONSUMPTION",
  TASK_SHARE_MULTI = "TASK_SHARE_MULTI",
  MINIBAR_FOR_CLEANER = "MINIBAR_FOR_CLEANER"
}
